module.exports = __webpack_public_path__ + "img/ValideGreen.7d12058f.svg";